export class BluechatProcess {
  public title: string;
  public id: string;
  public categories: string[];

  public static fromDto(data: any) {
    if (!data) {
      return null;
    }

    const process = new BluechatProcess();

    process.title      = data.title;
    process.id         = data.id;
    process.categories = data.categories;

    return process
  }
}
